import { Dispatch } from 'redux';

import * as Actions from '../actions/exercise';
import { IUserAttr } from '../actions/session';
import AbstractScenario from './AbstractScenario';

/** 課題一覧取得シナリオ用パラメータ */
export interface IFetchTaskListParam {
	careerID: string;
	classID: string;
	userAttr: IUserAttr;
}

/**
 * 課題一覧シナリオファクトリ
 */
export default class ExerciseScenarioFactory {
	/**
	 * 課題一覧取得シナリオ作成
	 */
	public static createFetchTaskList(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchTaskListParam
		> {
			protected process(arg: IFetchTaskListParam) {
				const param = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					accessType: 10,
					careerID: arg.careerID,
					classID: arg.classID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
					viewMode: 0,
				};
				return this.read(
					'per_imstat_TaskListBlockCollection',
					param
				).then(data => {
					const tasks = data.taskReportList.map((t: any) =>
						ExerciseScenarioFactory.toTask(t)
					);
					this.dispatch(
						Actions.setTasks({
							tasks,
						})
					);
				});
			}

			protected logError = (e: Error) => {
				// 呼び出し元でエラーハンドリングするため、そのままthrow
				throw e;
			};
		}(dispatch, token);
		return scenario;
	}

	// ITask
	protected static toTask = (from: any) => {
		const task: Actions.ITask = {
			expired: from.expired,
			kikan: from.kikan,
			reportFileName: from.reportFileName,
			reportMstFlg: from.reportMstFlg,
			reportMstFlgNum: from.reportMstFlgNum.present,
			resultStatus: from.resultStatus,
			resultStatusNum: from.resultStatusNum.present,
			seq: from.seq,
		};
		return task;
	};
}



// WEBPACK FOOTER //
// ./src/scenario/ExerciseScenarioFactory.ts